import React from 'react';
import { message } from "antd";
import { Modal, Table, Form, Empty } from 'antd';

class ReplicarPrecioModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
      }

      handleCancel = () => {
        this.props.onCancel();
        this.props.form.resetFields();
      };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
          console.log(values);
          if (values.selectedRowKeys.length === 0) {
            message.warning(
                ("Debe seleccionar mínimo una lista de precio.")
              );
              return;
          }
          if (!err) {
            const form = {
              idListaPrecio: values.idListaPrecio,
              idsListaPrecioReplica: values.selectedRowKeys
            };
            this.props.onSave(form, this.props.form);
          }
        });
      };

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator("idListaPrecio", { initialValue: this.props.formValues.idListaPrecio });
        getFieldDecorator("selectedRowKeys", { initialValue: this.props.formValues.selectedRowKeys });
        return (
            <Modal
                title={"Replicar Precios"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="800px"
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.id}
                                dataSource={this.props.formValues.dataSource}
                                rowSelection={{
                                    onChange: this.props.onChangeRow,
                                    selectedRowKeys: this.props.formValues.selectedRowKeys,
                                    hideDefaultSelections: false
                                }}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Nombre',
                                        dataIndex: 'nombre',
                                        key: 'nombre'
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}

export default Form.create()(ReplicarPrecioModal);